import React from 'react';
import './styles.scss';
import moment from 'moment';
import strings from 'utils/strings';
import {updateObject, updateItemInArray} from 'utils/reducerUtils';

const genders = [
	{label: 'Flicka', value: 'f'},
	{label: 'Pojke', value: 'm'},
	{label: 'Annat', value: 'u'},
];

const yesAndNo = [
	{label: 'Nej', value: 'no'},
	{label: 'Ja', value: 'yes'},
	{label: 'Vet inte', value: 'doesNotKnow'},
];

const allGrades = [
	{id: 1, value: 1, label: 'Årskurs 1'},
	{id: 2, value: 2, label: 'Årskurs 2'},
	{id: 3, value: 3, label: 'Årskurs 3'},
	{id: 4, value: 4, label: 'Årskurs 4'},
	{id: 5, value: 5, label: 'Årskurs 5'},
	{id: 6, value: 6, label: 'Årskurs 6'},
];

const now = moment();

class CandidateInfo extends React.Component {
	constructor(props) {
		super(props);
		this.updateTestUser = this.updateTestUser.bind(this);
		this.updateTestUserBirthDate = this.updateTestUserBirthDate.bind(this);
		this.state = {
			submitEnabled: true,
			isFormValid: false,
			candidateGrade: null,
			isNorming: 0,
			reqLang: 'swedish',
			excludeReading: 0,
			dateIsWrong: false,
			isForeign: '',
			showReadingTestOption: false,
			testUserInfo: {
				birthDate: '',
				firstName: '',
				lastName: '',
				gender: '',
				email: '',
				testDevice: '',

				age: {
					years: 0,
					months: 0,
				},
				education: {
					youthGrade: 0,
				},
			},
		};
	}
	updateTestUser(categoryKey, key, value) {
		const {testUserInfo} = this.state;

		if (categoryKey) {
			const category = updateObject(testUserInfo[categoryKey], {
				[key]: value,
			});

			this.setState({
				testUserInfo: updateObject(testUserInfo, {
					[categoryKey]: category,
				}),
			});
		} else {
			if (
				key === 'education' &&
				(value.youthGrade == 1 || value.youthGrade == 2)
			) {
				this.setState({
					testUserInfo: updateObject(testUserInfo, {
						[key]: value,
					}),
					showReadingTestOption: true,
				});
			} else if (
				key === 'education' &&
				value.youthGrade != 2 &&
				value.youthGrade != 3
			) {
				this.setState({
					testUserInfo: updateObject(testUserInfo, {
						[key]: value,
					}),
					showReadingTestOption: false,
					excludeReading: 0,
				});
			} else {
				this.setState({
					testUserInfo: updateObject(testUserInfo, {
						[key]: value,
					}),
				});
			}
		}
	}

	formatBirthDate(value) {
		const digits = value.replace(/\D/g, '').slice(0, 8);

		if (digits.length <= 4) {
			return digits;
		}

		if (digits.length <= 6) {
			return `${digits.slice(0, 4)}-${digits.slice(4)}`;
		}

		return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6)}`;
	}

	updateTestUserBirthDate(key, value, keyBirth, valBirth) {
		const {testUserInfo} = this.state;
		this.setState({
			testUserInfo: updateObject(testUserInfo, {
				[key]: value,
				[keyBirth]: valBirth,
			}),
		});
	}
	sendCodeAndInfoUsingEmail = (event, testUser, pin) => {
		event.preventDefault();
		const {age} = testUser;
		if (age.years < 3 || age.years > 90) {
			this.setState({dateIsWrong: true});
			return;
		}
		const {id, testKey, pinCode} = this.props.infoPanelTestKey;
		const {isNorming, reqLang} = this.state;
		const excludeReading = this.state.excludeReading;
		const {processTestResults, testResults} = this.props;

		const nextTestResults = updateItemInArray(
			testResults,
			id,
			(currentTestResult) =>
				updateObject(currentTestResult, {
					distributedAt: moment(),
				})
		);
		const nextBatchedTestResults = processTestResults(nextTestResults);

		this.props.onDistributeKeyAndStoreInfo(
			isNorming,
			testKey,
			testUser,
			excludeReading,
			pin,
			reqLang
		);
	};
	render() {
		const {isFormValid, testUserInfo} = this.state;
		const {pinCode, testKey: keyLable} = this.props.infoPanelTestKey;
		const {email, isForeign, gender} = testUserInfo;
		let formRef;

		const {testResults} = this.props;
		const {id, key: testKey, testUser} = testResults;

		let firstName;
		let lastName;
		let fullName;

		if (testUser) {
			email = testUser.email;
			firstName = testUser.firstName;
			lastName = testUser.lastName;
			fullName = `${firstName} ${lastName}`;
		}

		let emailInviteRef;
		return (
			<div
				className="lit-modal-candidate"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="lit-modal__continent"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div
						style={{
							width: '85%',
							margin: 'auto',
						}}
					>
						<div
							className="lit-candidate-info"
							onClick={() => {
								this.props.closeWindow();
							}}
						>
							<div
								className="lit-candidate-container"
								onClick={(event) => {
									event.stopPropagation();
								}}
							>
								<form
									className="lit-input-candidate"
									onChange={() => {
										const formValidity =
											formRef.checkValidity();

										if (
											isFormValid !== formValidity &&
											!this.state.dateIsWrong
										) {
											this.setState({
												isFormValid: formValidity,
											});
										}
									}}
									onSubmit={(e) => {
										e.preventDefault();
										this.sendCodeAndInfoUsingEmail(
											e,
											this.state.testUserInfo,
											pinCode
										);
									}}
									ref={(ref) => {
										formRef = ref;
									}}
								>
									<div className="lit-info__main-container">
										<div className="lit-info__main-container__wrapper1">
											<div className="lit-info__field">
												<h3
													className="lit-candidate-info-header__bolder"
													style={{
														fontSize: '15px',
														color: 'black',
														fontWeight: 'bold',
														padding: '10px',
													}}
												>
													{'Uppgifter om '}

													{'testkandidaten'}
												</h3>
												<div className="lit-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`firstName`}
													>
														{
															strings.candidateFirstName
														}
													</label>
													<div>
														<input
															className="lit-input__field"
															id={`firstName-${id}`}
															name={`firstName`}
															placeholder="Namn"
															onChange={(
																event
															) => {
																this.updateTestUser(
																	null,
																	'firstName',
																	event.target
																		.value
																);
															}}
															required
															type="text"
														/>
													</div>
												</div>
												<div className="lit-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`lastName`}
													>
														{
															strings.candidateLastName
														}
													</label>
													<div>
														<input
															className="lit-input__field"
															id="email"
															name="lastName"
															placeholder="Namnsson"
															onChange={(
																event
															) => {
																const value =
																	event.target
																		.value;
																this.updateTestUser(
																	null,
																	'lastName',
																	value
																);
															}}
															required
															type="text"
														/>
													</div>
												</div>
												<div className="lit-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`email`}
													>
														{strings.candidateEmail}
													</label>
													<div>
														<input
															className="lit-input__field"
															id={`email${id}`}
															name={`email`}
															placeholder="namn@epost.se"
															onChange={(
																event
															) => {
																this.updateTestUser(
																	null,
																	'email',
																	event.target
																		.value
																);
															}}
															type="email"
														/>
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label-gender">
													<label className="lit-test__heading">
														{
															strings.candidateGender
														}
													</label>

													<div className="lit-radio-group">
														{genders.map(
															(genderOption) => {
																const {
																	label: genderLabel,
																	value,
																} =
																	genderOption;

																return (
																	<span
																		className="lit-radio"
																		key={
																			value
																		}
																	>
																		<input
																			checked={
																				value ===
																				gender
																			}
																			className="lit-radio__field"
																			id={`gender${value}`}
																			name="gender"
																			onChange={() => {
																				this.updateTestUser(
																					null,
																					'gender',
																					value
																				);
																			}}
																			required
																			type="radio"
																		/>
																		<label
																			className="lit-radio__label"
																			htmlFor={`gender${value}`}
																		>
																			{
																				genderLabel
																			}
																		</label>
																	</span>
																);
															}
														)}
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label-gender">
													<label className="lit-test__heading">
														{
															'Har testkandidaten ett annat modersmål än svenska?'
														}
													</label>
													<div className="lit-radio-group">
														{yesAndNo.map(
															(genderOption) => {
																const {
																	label: genderLabel,
																	value,
																} =
																	genderOption;

																return (
																	<span
																		className="lit-radio"
																		key={
																			value
																		}
																	>
																		<input
																			checked={
																				value ===
																				isForeign
																			}
																			className="lit-radio__field"
																			id={`isForegin${value}`}
																			name="isForeign"
																			onChange={() => {
																				this.updateTestUser(
																					null,
																					'isForeign',
																					value
																				);
																			}}
																			required
																			type="radio"
																		/>
																		<label
																			className="lit-radio__label"
																			htmlFor={`isForeign${value}`}
																		>
																			{
																				genderLabel
																			}
																		</label>
																	</span>
																);
															}
														)}
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor="birthDate"
													>
														{
															strings.candidateBirthDate
														}
													</label>

													<div>
														<input
															className="lit-input__field"
															id={`birthDate-${id}`}
															type="text"
															placeholder="ÅÅÅÅ-MM-DD"
															name="birthDate"
															value={
																this.state
																	.testUserInfo
																	.birthDate
															}
															maxLength="10"
															onChange={(
																event
															) => {
																const value =
																	this.formatBirthDate(
																		event
																			.target
																			.value
																	);

																const isComplete =
																	value.length ===
																	10;
																const isValidDate =
																	moment(
																		value,
																		'YYYY-MM-DD',
																		true
																	).isValid();

																if (
																	!isComplete ||
																	!isValidDate
																) {
																	this.setState(
																		{
																			dateIsWrong:
																				value.length >
																				0,
																		}
																	);

																	this.updateTestUserBirthDate(
																		'age',
																		{
																			years: 0,
																			months: 0,
																		},
																		'birthDate',
																		value
																	);

																	return;
																}

																const age = {
																	years: now.diff(
																		value,
																		'years'
																	),
																	months:
																		now.diff(
																			value,
																			'months'
																		) % 12,
																};

																this.setState({
																	dateIsWrong:
																		!(
																			age.years >
																				2 &&
																			age.years <
																				90
																		),
																});

																this.updateTestUserBirthDate(
																	'age',
																	age,
																	'birthDate',
																	value
																);
															}}
															required
														/>
													</div>

													{this.state.dateIsWrong && (
														<span className="lit-error-message">
															Födelsedatum stämmer
															inte
														</span>
													)}
												</div>

												<div className="lit-candidate-label-grade">
													<label className="lit-test__heading">
														{strings.candidateGrade}
														<br />
													</label>

													<div>
														<select
															className="lit-input__field-trinn"
															id={`email-invite-${id}`}
															name={`youthGrade`}
															required="required"
															onChange={(
																event
															) => {
																const education =
																	{
																		youthGrade:
																			event
																				.target
																				.value,
																	};
																this.updateTestUser(
																	null,
																	'education',
																	education
																);
															}}
														>
															<option
																id={0}
																key={0}
																value=""
																disabled
																selected
															>
																{
																	strings.gradeDropDown
																}
															</option>
															{allGrades.map(
																(grades) => (
																	<option
																		id={
																			grades.id
																		}
																		key={
																			grades.id
																		}
																		value={
																			grades.value
																		}
																	>
																		{
																			grades.label
																		}
																	</option>
																)
															)}
														</select>
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label-pin-key">
													<label className="lit-test__heading">
														{'Pinkod'}
													</label>
													<div className="lit-input__field">
														<span className="lit-candidate-pin">
															{pinCode
																? pinCode
																: 'Skjult'}
														</span>
													</div>
												</div>
												<div className="lit-candidate-label-pin-key">
													<label className="lit-test__heading">
														{'Testnyckel'}
													</label>
													<div className="lit-input__field">
														<span className="lit-candidate-pin">
															{keyLable}
														</span>
													</div>
												</div>
											</div>
										</div>

										<div className="lit-info__main-container__wrapper2">
											{/* <div className="lit-fill-space">
											<br></br>
											<br></br>
											<br></br>
											<br></br>
											<br></br>
										</div> */}
											<div className="lit-info__field-text">
												<p>
													{
														strings.testCandidateTakeTestWith
													}
												</p>
												<li>
													{strings.gotoDysmtateSite}
												</li>
												<li>
													{
														strings.testCommenceInstructions1
													}
												</li>
												<li>
													{
														strings.testCommenceInstructions2
													}
												</li>
												<li>
													{
														strings.testCommenceInstructions3
													}
												</li>
												<p>
													{
														strings.testCommenceInstructions4
													}
												</p>
												<li>
													{
														strings.testCommenceInstructions5
													}
												</li>
												<p>
													{
														strings.testCommenceInstructions6
													}
												</p>
											</div>

											{this.state
												.showReadingTestOption && (
												<div className="lit-info__field-fifth">
													<label className="lit-test__heading lit-reading-question">
														{
															strings.question_excludeReadingTest
														}
													</label>

													<div className="lit-radio-group lit-radio-group--inline">
														{yesAndNo.map(
															({
																label,
																value,
															}) => {
																const inputId = `excludeReading-${value}`;

																return (
																	<span
																		className="lit-radio"
																		key={
																			value
																		}
																	>
																		<input
																			checked={
																				value ===
																				this
																					.state
																					.excludeReading
																			}
																			className="lit-radio__field"
																			id={
																				inputId
																			}
																			name="excludeReading"
																			onChange={() => {
																				this.setState(
																					{
																						excludeReading:
																							value,
																					}
																				);
																			}}
																			required
																			type="radio"
																		/>

																		<label
																			className="lit-radio__label"
																			htmlFor={
																				inputId
																			}
																		>
																			{
																				label
																			}
																		</label>
																	</span>
																);
															}
														)}
													</div>
												</div>
											)}

											<div className="lit-info__field-fifth">
												<div>
													<span className="lit-fill-out-info-consent">
														<input
															type="checkbox"
															name="agreedToPrivacyPolicy"
															required
															className="user_checkbox2"
														/>{' '}
														{strings.iConsent}
													</span>
													<br />

													{strings.formatString(
														strings.constTestChild,
														<a
															target="_blank"
															rel="noopener noreferrer"
															href="https://www.dysmate.se/personvernerklaering/"
														>
															<u>
																{
																	strings.privacyPolicy
																}
															</u>
														</a>
													)}
												</div>
												<div className="lit-btn-submit-from">
													<button
														type="submit"
														disabled={
															!isFormValid ||
															this.state
																.dateIsWrong
														}
														className={
															isFormValid &&
															!this.state
																.dateIsWrong
																? 'lit-btn lit-btn bg-primary-glow'
																: 'lit-btn lit-btn bg-primary-dark'
														}
													>
														{strings.sendtest}
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CandidateInfo;
